export class CardTokenizationError extends Error {}

export const isCardTokenizationError = (error: unknown): error is CardTokenizationError =>
    error instanceof CardTokenizationError;
